import React from 'react';
import { useTranslation } from 'react-i18next';
import { Edit3, Trash2 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';

export type TextAreaPopupMenuProps = Omit<
  React.ComponentProps<typeof PopupMenu>,
  'onOutside' | 'children'
> & {
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
};

export const TextAreaPopupMenu: React.FC<TextAreaPopupMenuProps> = ({
  onEdit,
  onDelete,
  onClose,
  ...rest
}) => {
  const { t } = useTranslation();

  const _onEdit = () => {
    onEdit();
    onClose();
  };

  const _onDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <PopupMenu onOutside={onClose} {...rest}>
      <PopupMenuList>
        <PopupMenuListItem>
          <PopupMenuButton start={<Icon icon={Edit3} />} onClick={_onEdit}>
            {t('context-menus.url-parser.edit.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
        <PopupMenuListItem>
          <PopupMenuButton start={<Icon icon={Trash2} />} onClick={_onDelete}>
            {t('context-menus.url-parser.delete.label')}
          </PopupMenuButton>
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
